import { el, button } from "../lib/dom.ts";
import { setSafeHtml } from "../lib/sanitize.ts";
import { humanizeError } from "../lib/errorCopy.ts";

// The He/En source-body block, shared by the navigator reader, the Source Desk, and
// the peek sheet. setSafeHtml is the sanitizer chokepoint - the ONLY place these
// surfaces inject the verbatim Sefaria body HTML; every title/label renders via
// textContent elsewhere. extraClass adds a modifier (the desk passes "desk-stext").
export function textBlock(he: string, en: string | null, extraClass = ""): HTMLElement {
  const d = el("div", extraClass ? `stext ${extraClass}` : "stext");
  const h = el("div", "she");
  h.lang = "he";
  h.dir = "rtl";
  setSafeHtml(h, he);
  d.append(h);
  if (en) {
    const e = el("p", "sen");
    e.lang = "en";
    setSafeHtml(e, en);
    d.append(e);
  }
  return d;
}

// The inline load-error row (role=alert). Copy is humanized at the boundary
// (errorCopy.ts) - never a raw internal string. A spent-budget error always
// offers Refresh (Retry could never succeed); otherwise Retry shows only on the
// reloadable panels (pass `retry`); read-only surfaces (peek, desk) omit it.
export function errorRow(err: unknown, retry?: () => void): HTMLElement {
  const d = el("div", "srowerr");
  d.setAttribute("role", "alert");
  const friendly = humanizeError(err);
  d.append(el("span", "", friendly.message));
  if (friendly.action === "refresh") {
    d.append(button("btn btn-sm", "Refresh", () => location.reload()));
  } else if (retry) {
    d.append(button("btn btn-sm", "Retry", retry));
  }
  return d;
}
